import { Link } from 'react-router-dom';
import classNames from 'classnames';

import './CollectionLink.less';
import NewFeatureTag from '../../components/NewFeatureTag';

function CollectionLink({
  to,
  active,
  children,
  newCollection,
}: {
  to: string;
  active: boolean;
  children: React.JSX.Element | React.JSX.Element[] | string;
  newCollection?: boolean;
}) {
  return (
    <span className="__CollectionLink__ mh4 m-mh2">
      <Link className={classNames('link f5 white', { active })} to={to}>
        {children}
      </Link>
      {newCollection && <NewFeatureTag />}
    </span>
  );
}

export default CollectionLink;
